
const SHUFFLE_PAGES_VARIANTS_CONFIG = {
  '/': [
    '/__pv/0',
    '/__pv/1',
    '/__pv/2',
    '/__pv/3',
  ],
}

export {
  SHUFFLE_PAGES_VARIANTS_CONFIG,
}